import './components/second-slider';
import './components/main-slider';
import './components/parallax';
import './components/parallax2';
import './components/burger';
import './components/backButton';
// import './components/rellax';
